import React from 'react'
import "./timesheet.scss"
import { CloseIcon } from '../../assets/images'

type AppProps={
    data:any;
    // handleDeleteTimeSheet:(data:string|number)=>void;
}

const TimeSheetGap = ({
    data,
    // handleDeleteTimeSheet
}:AppProps) => {
  return (
    <div className='gap-card'>
      <div className='inside-card-header'>Gap Between {`${data?.start_time} To ${data?.end_time}`}</div>
      {/* <div onClick={()=>handleDeleteTimeSheet(data._id)}>
        <img src={CloseIcon} alt="" />
      </div> */}
    </div>
  )
}

export default TimeSheetGap